import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useCrmAccess } from '@/lib/crm/use-crm-access';

/** `/crm` opens the first CRM tab the caller may see. The parent layout has already gated entry. */
export const Route = createFileRoute('/crm/')({
  component: CrmHome,
});

function CrmHome() {
  const { visibleNav } = useCrmAccess();
  const first = visibleNav[0];
  return first ? <Navigate to={first.to} replace /> : null;
}
